<div class="container">
  <div class="content-div">
    <div class="accessibility-statement">
      <p class="accessibility-title">Accessibility Statement</p>
      <p class="accessibility-text">
        ETS is committed to making the Compass platform accessible to all users. 
        Compass is currently undergoing active remediation to achieve 
        WCAG 2.2 Level AA compliance by April 2026. Known barriers include keyboard navigation, 
        focus indicators, status messages, and resizable text, which may affect users 
        who are blind, have low vision, or have limited manual dexterity. 
        A Temporary Alternative Access Plan (TAAP) is in place, and students encountering 
        difficulties should contact their campus accessibility office or email 
        <a 
          href="mailto:accessibility&#64;ets.org" 
          class="accessibility-link"
        >
          accessibility&#64;ets.org
        </a> 
        for support and alternative formats. While best efforts have been made to 
        identify barriers, additional accessibility issues may exist. 
        To access the latest version of this statement, contact 
        <a 
          href="mailto:accessibility&#64;ets.org" 
          class="accessibility-link"
        >
          accessibility&#64;ets.org
        </a>.
      </p>
    </div>
  </div>
</div>